var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"50px","height":"60px","background":"pink"},on:{"click":_vm.wxShareAppMessage}},[_vm._v(" 123 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }